import auth from '@groovepages/gd-lib/auth';
import store from '@/store';
import { grooveSellUrl, rememberGrooveSellReturn } from '@/services/return-path';

export default async (to, from, next) => {
  if (auth.authenticatedUser()) {
    store.commit('login', auth.authenticatedUser());
    next();
  } else {
    store.commit('logout');
    rememberGrooveSellReturn(
      localStorage,
      grooveSellUrl(
        window.location.origin,
        to.fullPath,
        process.env.NODE_ENV === 'development'
      )
    );
    window.location.replace(`${window.config.grooveappsurl}/#/login`);
  }
};
